import {
  GetInfraTaskTicketResponse,
  StupTask,
  TcktDesc,
} from "../../services/ticket/get-infra-task-ticket/GetInfraTaskResponse";
import { DisplayColumn, ErrorMessage } from "../../util";
import { Option } from "../../util/option";

export type TicketDetailPageState = {
  searchResult: GetInfraTaskTicketResponse;
  dataList: {
    tcktStsTypeCpntStgStupTask: Option[];
    tcktStsTypeCpntPrdStupTask: Option[];
    tcktStsTypeCpntOtherStgStupTask: Option[];
    inDefCommonFlagType: Option[];
    roleType: Option[];
  };
  formValidation: FormValidation;
  tcktStsList: Option[];
  fieldPath: FieldPath;
  displayColumn: DisplayColumn[];
  spreadsheet: {
    selectRowIdx?: number;
    tmplateRow: InfraTaskSpreadsheetRecordData;
  };
  isEdited: boolean;
};

export type InfraTaskSpreadsheetState = {
  stupTasksList: InfraTaskSpreadsheetRecordData[];
  dataList: {
    tcktStsTypeCpntStgStupTask: Option[];
    tcktStsTypeCpntPrdStupTask: Option[];
    tcktStsTypeCpntOtherStgStupTask: Option[];
    inDefCommonFlagType: Option[];
  };
  necFlgCell: NecFlgCell;
};

export type FormValidation = {
  dueDate: boolean;
  tcktStsTypeCd: boolean;
  tcktDesc: boolean;
};

export type InfraTaskSpreadsheetRecordData = {
  stupTaskCtgryId: string;
  cpntPrtclCtgryTypeCd: string;
  cpntPrtclCtgryTypeName: string;
  prtclTypeCd: string;
  prtclTypeName: string;
  updateDateTime: string;
  stupTaskList: StupTask[];
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export type DescriptionHistorySpreadsheetState = {
  tcktDescList: TcktDesc[];
  removeMilliseconds: (timestamp: string) => string;
};

type FieldPath = {
  dueDate: string;
  tcktSts: string;
  desc: string;
};
export type NecFlgCell = {
  [key: string]: {
    isDirty: boolean;
    initialValue: string;
    currentValue: string;
  };
};

export type PageNewState =
  | TicketDetailPageState
  | ((prevState: TicketDetailPageState) => TicketDetailPageState);
